 
import { call, takeLatest } from 'redux-saga/effects';
import * as api from '@api/qcTask';
import { actions } from './QCTaskUploadsList.slice';
import {
  QCTaskUploadsListFetchAction,
  QCTaskFetchEDTFAction,
  QCTaskUploadsSendToWorkstationAction,
  QCTaskUploadFetchAction,
} from './QCTaskUploadsList.types';
import { Resp, dispatch } from '../helpers';
import { runToast } from '@restore/tools';
import axios from 'axios';

export function* fetchQCTaskUploadsListWorker(
  action: QCTaskUploadsListFetchAction
) {
  try {
    const response: Resp<typeof api.fetchQCTaskUploads> = yield call(
      api.fetchQCTaskUploads,
      action.payload.clinicalTrialId,
      action.payload.taskId
    );
    yield dispatch(
      actions.fetchQCTaskUploadsListSuccess(response.data.uploads)
    );
  } catch (error) {
    yield dispatch(actions.fetchQCTaskUploadsListFailure(error as Error));
  }
}

export function* QCTaskUploadsFetchEDTFWorker(action: QCTaskFetchEDTFAction) {
  try {
    const response: Resp<typeof api.fetchQCTaskUploadEdtf> = yield call(
      api.fetchQCTaskUploadEdtf,
      action.payload.clinicalTrialId,
      action.payload.taskId,
      action.payload.uploadId
    );
    yield dispatch(actions.fetchEDTFSuccess(response.data));
  } catch (error) {
    yield dispatch(actions.fetchEDTFFailure(error as Error));
  }
}

export function* fetchQCTaskUploadsSendToWorkStationWorker(
  action: QCTaskUploadsSendToWorkstationAction
) {
  try {
    yield call(
      api.fetchQCTaskUploadSendToWorkStation,
      action.payload.clinicalTrialId,
      action.payload.taskId,
      action.payload.uploadId
    );
    yield dispatch(actions.fetchSendToWorkStationSuccess(action.payload));
  } catch (e) {
    yield call(
      runToast,
      'error',
      (axios.isAxiosError(e) && e.response?.data?.detail) ||
        'Failed to send to workstation'
    );
    yield dispatch(actions.fetchSendToWorkStationFailure(action.payload));
  }
}

export function* fetchQCTaskUploadWorker(action: QCTaskUploadFetchAction) {
  try {
    const response: Resp<typeof api.fetchQCTaskUpload> = yield call(
      api.fetchQCTaskUpload,
      action.payload.clinicalTrialId,
      action.payload.taskId,
      action.payload.uploadId
    );
    yield dispatch(actions.fetchQCTaskUploadSuccess(response.data));
  } catch (error) {
    console.error(error);
    yield dispatch(actions.fetchQCTaskUploadError());
  }
}

export function* QCTaskUploadsListSaga() {
  yield takeLatest(
    actions.fetchQCTaskUploadsList.type,
    fetchQCTaskUploadsListWorker
  );
  yield takeLatest(actions.fetchEDTF.type, QCTaskUploadsFetchEDTFWorker);
  yield takeLatest(
    actions.fetchSendToWorkStation.type,
    fetchQCTaskUploadsSendToWorkStationWorker
  );
  yield takeLatest(actions.fetchQCTaskUpload.type, fetchQCTaskUploadWorker);
}
